import { Dialog, DialogProps } from '@mui/material';
import { usePresence } from 'framer-motion';

type Props = Omit<DialogProps, 'open'> & { open?: boolean };

/**
 * Диалог, который под AnimatePresence закрывается с анимацией: условие показа гасит open,
 * а из дерева диалог уходит после onExited. Без AnimatePresence работает как обычный
 */
const PresenceDialog: React.FC<Props> = ({ open = true, slotProps, ...props }) => {
  const [isPresent, safeToRemove] = usePresence();

  return (
    <Dialog
      {...props}
      open={open && isPresent}
      slotProps={{ ...slotProps, transition: { onExited: () => safeToRemove?.() } }}
    />
  );
};

export { PresenceDialog };
